/* tslint:disable */
export var icon = "\n<svg width=\"7\" height=\"10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.587 5L0 .872.669.128 6.082 5 .669 9.872 0 9.128 4.587 5z\" fill=\"#3899EC\"/></svg>\n";
//# sourceMappingURL=small-arrow.svg.js.map